import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { logOut } from '../../store/reducers/auth'
import { showModal } from '../../store/reducers/modal'
import STSComponent from "../STSComponent/STSComponent"
import ClientHeader from './components/ClientSide/ClientHeader'
import IntranetHeader from './components/IntranetSide/IntranetHeader'

class Header extends STSComponent {
  constructor (props) {
    super(props)
    this.state = {
      isOpenResources: false,
      isOpenSettings: false,
      enabledColor: false
    }
    this.signOut = this.signOut.bind(this)
  }

  signOut = () => {
    this.props.logOut()
    localStorage.removeItem('authData')
  }

  render () {
    const { location, authData, showModal } = this.props
    const intranet = authData && authData.Permissions && authData.Permissions.includes('Intranet')
    if (intranet) {
      return <IntranetHeader
        location={location}
        authData={authData}
        permissions={authData.Permissions}
        showModal={showModal}
        signOut={this.signOut}
      />
    } else {
      return <ClientHeader
        signOut={this.signOut}
        location={location}
        authData={authData}
        permissions={authData.Permissions}
        showModal={showModal}
      />
    }
  }

  static propTypes = {
    logOut: PropTypes.func,
    authData: PropTypes.object,
    location: PropTypes.object,
    showModal: PropTypes.func
  }
}

export default connect(state => ({
  authData: state.auth.authData,
  location: state.router.location
}), {
  logOut,
  showModal
})(Header)



// WEBPACK FOOTER //
// ./src/components/Header/Header.js